import OrgsReducer from './reducers';

const orgsReducers = {
  allOrgs: OrgsReducer.allOrgsReducer,
};

export { orgsReducers };
